<template id="progressRing">
    <svg :style="cssVars" class="progress-ring" viewBox="-60,-60,120,120">
        <circle class="progress-ring-circle" r="46" />
        <path class="progress-ring-ring" :d="path" />
        <text class="progress-ring-text" alignment-baseline="middle" text-anchor="middle">{{ mins }}:{{ secs }}</text>
    </svg>
</template>

<script>
import posed from "vue-pose"

import { clearInterval, setInterval, clearTimeout } from 'timers';
export default {
    template: '#progressRing',
    props: {
        value: {
            type: Number,
            default: 120,
        },
        min: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
            default: 1,
        },
        showText: {
            type: Boolean,
            default: true
        },
        ringColor: {
            type: String,
            default: '#007fff'
        },
        textColor: {
            type: String,
            default: '#007fff'
        },
        step: {
            type: String,
            default: null
        },
        currentStep: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            currentCount: 0,
            text: this.max - this.currentCount
        }
    },
    created() {
        this.currentCount = this.value
    },
    computed: {
        theta() {
            const frac = (this.currentCount - this.min) / (this.max - this.min) || 0;
            return frac * 2 * Math.PI;
        },
        path() {
            const large = this.theta > Math.PI;
            const full = (this.theta / 2) > Math.PI;
            return `M0,-46 A46,46,0,${large ? 1 : 0},${full ? 0 : 1},${this.endX},${this.endY}`;
        },
        endX() {
            return Math.cos(this.theta - Math.PI * 0.5) * 46;
        },
        endY() {
            return Math.sin(this.theta - Math.PI * 0.5) * 46;
        },
        mins() {
            return Math.floor(this.text / 60)
        },
        secs() {
            return (this.text - this.mins * 60).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})
        },
        cssVars() {
           return {
                '--ringColor': this.ringColor,
                '--textColor': this.textColor
            }
        }
    },
    methods: {
        count() {
            this.currentCount -= 0.05
            this.text = Math.round(this.currentCount)
            if (this.currentCount <= 0 && this.step == this.currentStep) this.clearTimer(false), this.$root.$emit('skip')
        },
        startTimer() {
            this.resetCount()
            if (!this.$options.interval) {
                this.$options.interval = setInterval(this.count, 50)
            }
        },
        resetCount() {
            this.text = this.max
            this.currentCount = this.max
        },
        clearTimer(reset, start) {
            if (this.$options.interval) clearInterval(this.$options.interval), this.$options.interval = null
            if (start) this.startTimer()
            else if (reset) this.resetCount()
        }
    },
    mounted() {
        this.$root.$on('startTimer', () => {
            this.startTimer()
        }),
        this.$root.$on('resetTimer', (reset, start) => {
            this.clearTimer(reset, start)
        })
    },
    beforeDestroy() {
        this.clearTimer(true)
    }
}
</script>

<style lang="scss">
    .progress-ring {
        width: 60px;
        height: 60px;

        text {
            font-weight: bold;
            font-size: 1.6rem;
            color: var(--textColor) !important;
        }
    }

    .progress-ring-circle {
        stroke: rgba(0, 0, 0, 0.1);
        stroke-width: 1;
        fill: none;
    }

    .progress-ring-ring {
        stroke: var(--ringColor);
        stroke-width: 15;
        fill: none;
    }

    .progress-ring-end {
        fill: var(--ringColor);
    }
</style>